export enum CreatePageStepsEnum {
  DealType = 'dealType',
  PropertyType = 'propertyType',
  Form = 'form'
}

export type ValuesType = {
  [key: string]: string | undefined | boolean | number;
};

export interface CreateNewItemsProps {
  accessToken?: string;
  values: ValuesType;
}
